module.exports = __webpack_public_path__ + "img/figure-28.73436db2.png";